import { useContext } from 'react'

import { FrameBuilderSelectionContext } from '../../contexts/selection-context'
import { FrameBuilderStringsContext } from '../../contexts/strings-context'
import { FrameBuilderValidationContext } from '../../contexts/validation-context'

import ConfigurationStepPreview, {
  type StepPreviewProps,
} from './configuration-step-preview'

const ArtworkImageStepPreview = ({ number, onClick }: StepPreviewProps) => {
  const frameBuilderStrings = useContext(FrameBuilderStringsContext)
  const { committedStateSelectionMessages } = useContext(
    FrameBuilderSelectionContext,
  )
  const { stepPreviewAnimation } = useContext(FrameBuilderValidationContext)

  return (
    <ConfigurationStepPreview
      step="artworkImage"
      title={frameBuilderStrings.artworkPreviewStepTitle}
      value={committedStateSelectionMessages?.artworkImage}
      placeholder={frameBuilderStrings.artworkPreviewPlaceholder}
      opacity={stepPreviewAnimation.artworkImageOpacity}
      number={number}
      onClick={onClick}
      className="grow-0 shrink-0"
      valueClassName="break-all"
    />
  )
}

export default ArtworkImageStepPreview
